<template>
  <v-app>
    <app-header />
    <app-sidebar />
    <v-main>
      <div class="page-wrapper">
        <v-container fluid class="page-content">
          <router-view />
        </v-container>
      </div>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import AppHeader from './AppHeader.vue';
import AppSidebar from './AppSidebar.vue';
</script>

<style scoped>
.page-wrapper {
  min-height: 100dvh;
  padding: 16px 12px 24px;
  background: linear-gradient(170deg, #f0f4fa 0%, #f8f9fb 40%, #ffffff 100%);
}

.page-content {
  max-width: 1080px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 12px;
  padding-right: 12px;
}
</style>
